/**
 * AgDrone AU postcode → town-name picker.
 * Fills hidden `state` + `zip` so HubSpot still gets city / state / postcode.
 */
(function (w, d) {
  if (w.__agdPostcodeTown) {
    w.__agdPostcodeTown.scan();
    return;
  }

  function stateFromPostcode(pc) {
    var n = parseInt(String(pc || '').replace(/\D/g, '').slice(0, 4), 10);
    if (!n) return '';
    if ((n >= 1000 && n <= 1999) || (n >= 2000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
    if ((n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920) || (n >= 200 && n <= 299)) return 'ACT';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
    if ((n >= 5000 && n <= 5799) || (n >= 5800 && n <= 5999)) return 'SA';
    if ((n >= 6000 && n <= 6797) || (n >= 6800 && n <= 6999)) return 'WA';
    if ((n >= 7000 && n <= 7799) || (n >= 7800 && n <= 7999)) return 'TAS';
    if ((n >= 800 && n <= 899) || (n >= 900 && n <= 999)) return 'NT';
    return '';
  }

  var dataPromise = null;
  function load() {
    if (w.AGD_AU_POSTCODES) return Promise.resolve(w.AGD_AU_POSTCODES);
    var url = w.AGD_AU_POSTCODES_URL;
    if (!url) {
      return new Promise(function (resolve) {
        var n = 0;
        var t = setInterval(function () {
          n += 1;
          if (w.AGD_AU_POSTCODES || n > 40) {
            clearInterval(t);
            resolve(w.AGD_AU_POSTCODES || null);
          }
        }, 50);
      });
    }
    if (!dataPromise) {
      dataPromise = fetch(url, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return dataPromise;
  }

  function digits4(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 4);
  }

  function setTownMode(root, mode) {
    var select = root.querySelector('[data-agd-town]');
    var other = root.querySelector('[data-agd-town-other]');
    if (!select || !other) return;
    var useOther = mode === 'other';
    select.hidden = useOther;
    select.disabled = useOther;
    other.hidden = !useOther;
    other.disabled = useOther;
    if (useOther) {
      select.removeAttribute('name');
      select.removeAttribute('required');
      other.setAttribute('name', 'town');
      other.required = true;
    } else {
      other.removeAttribute('name');
      other.removeAttribute('required');
      other.value = '';
      select.setAttribute('name', 'town');
      select.required = true;
    }
  }

  function resetTown(root, placeholder) {
    var select = root.querySelector('[data-agd-town]');
    var stateEl = root.querySelector('[data-agd-state]');
    var zipEl = root.querySelector('[data-agd-zip]');
    if (stateEl) stateEl.value = '';
    if (zipEl) zipEl.value = '';
    if (select) {
      select.innerHTML = '';
      var opt = d.createElement('option');
      opt.value = '';
      opt.disabled = true;
      opt.selected = true;
      opt.textContent = placeholder || 'Enter postcode first';
      select.appendChild(opt);
    }
    setTownMode(root, 'select');
    emit(root);
  }

  function emit(root) {
    var pc = digits4((root.querySelector('[data-agd-postcode]') || {}).value);
    var state = ((root.querySelector('[data-agd-state]') || {}).value) || '';
    var select = root.querySelector('[data-agd-town]');
    var other = root.querySelector('[data-agd-town-other]');
    var town = '';
    if (other && !other.hidden && !other.disabled) town = String(other.value || '').trim();
    else if (select && !select.hidden) town = String(select.value || '').trim();
    root.dispatchEvent(new CustomEvent('agd-loc-change', {
      bubbles: true,
      detail: { postcode: pc, town: town, state: state }
    }));
  }

  function fill(root, rec, pc) {
    var select = root.querySelector('[data-agd-town]');
    var stateEl = root.querySelector('[data-agd-state]');
    var zipEl = root.querySelector('[data-agd-zip]');
    if (zipEl) zipEl.value = pc;
    var state = (rec && rec.s) || stateFromPostcode(pc);
    if (stateEl) stateEl.value = state;
    var names = rec && Array.isArray(rec.t) ? rec.t : [];
    if (!select || !names.length) {
      setTownMode(root, 'other');
      emit(root);
      return;
    }
    setTownMode(root, 'select');
    select.innerHTML = '';
    if (names.length === 1) {
      var only = d.createElement('option');
      only.value = names[0];
      only.textContent = names[0];
      only.selected = true;
      select.appendChild(only);
    } else {
      var ph = d.createElement('option');
      ph.value = '';
      ph.disabled = true;
      ph.selected = true;
      ph.textContent = 'Select town…';
      select.appendChild(ph);
      names.forEach(function (name) {
        var o = d.createElement('option');
        o.value = name;
        o.textContent = name;
        select.appendChild(o);
      });
    }
    emit(root);
  }

  function bind(root) {
    if (!root || root.dataset.agdLocBound === '1') return;
    root.dataset.agdLocBound = '1';
    var pcEl = root.querySelector('[data-agd-postcode]');
    if (!pcEl) return;

    function onPc() {
      var pc = digits4(pcEl.value);
      if (pcEl.value !== pc) pcEl.value = pc;
      if (pc.length < 4) {
        resetTown(root, 'Enter postcode first');
        return;
      }
      load().then(function (db) {
        if (digits4(pcEl.value) !== pc) return;
        fill(root, db && db[pc], pc);
      });
    }

    pcEl.addEventListener('input', onPc);
    pcEl.addEventListener('change', onPc);
    var select = root.querySelector('[data-agd-town]');
    var other = root.querySelector('[data-agd-town-other]');
    if (select) select.addEventListener('change', function () { emit(root); });
    if (other) other.addEventListener('input', function () { emit(root); });

    var form = root.closest('form');
    if (form) {
      form.addEventListener('reset', function () {
        setTimeout(function () { resetTown(root, 'Enter postcode first'); }, 0);
      });
    }
    if (pcEl.value) onPc();
    else resetTown(root, 'Enter postcode first');
  }

  function scan(scope) {
    (scope || d).querySelectorAll('[data-agd-loc]').forEach(bind);
    load();
  }

  function normalize(data) {
    var pc = digits4(data.postcode || data.zip);
    if (pc) {
      data.postcode = pc;
      data.zip = pc;
    }
    if (!data.state && pc) data.state = stateFromPostcode(pc);
    return data;
  }

  w.__agdPostcodeTown = { scan: scan, bind: bind, normalize: normalize, stateFromPostcode: stateFromPostcode };
  w.agdNormalizeLeadLocation = normalize;
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})(window, document);
